import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { ProjectId } from 'api/models';
import { FetchStatus } from 'data/core';
import { selectStatusUpdates } from 'data/status-updates';
import { saveTasks } from 'data/tasks/slice';
import { useProjectTasksQuery } from 'queries/task';
import { logger } from 'services';
import { StatusUpdatesEmptyState } from './empty-state';
import { StatusUpdates } from './list';

export const StatusUpdatesContainer = (): JSX.Element => {
  const statusUpdates = useSelector(selectStatusUpdates);

  const dispatch = useDispatch();
  const { projectId: projectIdParam, statusUpdateId: statusUpdateIdParam } =
    useParams<{
      statusUpdateId: string;
      projectId: string;
    }>();

  const projectId = parseInt(projectIdParam, 10);
  const statusUpdateId = statusUpdateIdParam
    ? parseInt(statusUpdateIdParam, 10)
    : null;

  useProjectTasksQuery(ProjectId(projectId), {
    retry: 1,
    refetchOnMount: true,
    staleTime: 0,
    onSuccess: async (tasks) => {
      try {
        dispatch(saveTasks({ data: tasks, fetchStatus: FetchStatus.Loaded }));
      } catch (error) {
        logger.error('failed to fetch tasks', { error });
      }
    },
  });

  return statusUpdates.length ? (
    <StatusUpdates
      items={statusUpdates}
      activeStatusUpdateId={statusUpdateId}
    />
  ) : (
    <StatusUpdatesEmptyState />
  );
};
